var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title_key!=='')?_c('div',{staticClass:"form-check btn-choice"},[_c('button-choice',{attrs:{"selected":_vm.selected,"type":"button","text":_vm.title},on:{"click":_vm.choiceClicked}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }